import { type FC, memo } from 'react';
import type { CreationWithTask, TaskInfo } from '@/app/types';
import type { DisplayTaskState } from '../../../_components/TaskCard/types';
import { TaskHistory } from '../../../_components/TaskHistory';

const OFFLINE_AVATAR_HISTORY_TASK_TYPE_KEYS: TaskInfo['type'][] = ['offline_avatar'];
const OFFLINE_AVATAR_HISTORY_CLASS_NAME =
  '!h-full !min-h-0 !rounded-0 !bg-transparent !px-0 [&>div]:!px-0 [&_button]:!rounded-12 [&_.space-y-9]:space-y-3 [&_[id^=radix]]:hidden';
const OFFLINE_AVATAR_HISTORY_PROCESSING_FILTER_CLASS_NAME = '!static !bg-transparent [&>div]:!mt-0 [&>div]:!pt-0';

interface OfflineAvatarHistoryPanelProps {
  scrollableTargetId: string;
  onCompactCreationSelect: (creation: CreationWithTask) => void;
  onCompactTaskSelect: (task: TaskInfo, creation?: CreationWithTask, taskState?: DisplayTaskState) => void;
}

export const OfflineAvatarHistoryPanel: FC<OfflineAvatarHistoryPanelProps> = memo(
  ({ scrollableTargetId, onCompactCreationSelect, onCompactTaskSelect }) => (
    <aside className="flex min-h-0 w-[144px] min-w-0 shrink-0 flex-col overflow-hidden bg-transparent pr-1 sm:h-[360px] sm:w-full sm:rounded-none sm:bg-transparent sm:p-0">
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <div id={`${scrollableTargetId}-history`} className="min-h-0 flex-1 overflow-y-auto">
          <TaskHistory
            className={OFFLINE_AVATAR_HISTORY_CLASS_NAME}
            processingFilterClassName={OFFLINE_AVATAR_HISTORY_PROCESSING_FILTER_CLASS_NAME}
            showOngoingFilter
            showUpgradeBanner={false}
            showTaskTypeFilter={false}
            scrollableTargetId={`${scrollableTargetId}-history`}
            defaultTaskTypeKeys={OFFLINE_AVATAR_HISTORY_TASK_TYPE_KEYS}
            onCompactCreationSelect={onCompactCreationSelect}
            onCompactTaskSelect={onCompactTaskSelect}
            compact
          />
        </div>
      </div>
    </aside>
  ),
);

OfflineAvatarHistoryPanel.displayName = 'OfflineAvatarHistoryPanel';
